import { render, staticRenderFns } from "./backend-performance.vue?vue&type=template&id=88b7c802&scoped=true"
import script from "./backend-performance.vue?vue&type=script&lang=js"
export * from "./backend-performance.vue?vue&type=script&lang=js"
import style0 from "./backend-performance.vue?vue&type=style&index=0&id=88b7c802&prod&scoped=true&lang=css"
import style1 from "./backend-performance.vue?vue&type=style&index=1&id=88b7c802&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b7c802",
  null
  
)

export default component.exports